import axios from '@utils/http'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  facilityAdd({ commit, dispatch, getters }, { facility }) {
    return axios.post(`/api/facilities`, facility).then(response => {
      const facility = response.data
      return facility
    })
  },

  changeFacility({ commit, dispatch, getters }, { facilityId }) {
    return axios
      .post(`/api/session/changeFacility`, {
        facilityId: facilityId,
      })
      .then(response => {
        return response
      })
  },
}
